import { Fragment } from 'react/jsx-runtime';
import ProxyButton from '../../components/common/ProxyButton';
import {
  TOTP_PROVIDER_AMPLITUDE_EVENT
} from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { createWrapper } from '../../utils/react-utils';
import React from 'react';
import BaseForgeCustomizer from '../base-forge';
import ProxyFooter from '../../components/common/ProxyFooter';
import SecretKeyInstructionsClassic from '../../components/enroll-manual-push/SecretKeyInstructionsClassic';
import { getLocalizedString } from '../../utils/i18n-utils';

export default class EnrollManualTotpCustomizer extends BaseForgeCustomizer {

  displayFooterText = true;
  headerText = getLocalizedString('totp.enroll.step.1.header.text');
  headerDescription = ' ';

  async shouldCustomize() {
    return [ 'enroll-manual-totp' ].includes(this.context.controller);
  }

  forgifyController() {
    this.oktaSignIn.router.appState.set('isManualTotpSetup', true);
    super.forgifyController();
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT[this.provider]}TotpManualSetup::Landing`);
    this.forgifySecretKeyInstructionsText();
    this.alterAthenaSecretKeyInstructions();
    this.moveScanQrCodeButton();
  }

  private alterAthenaSecretKeyInstructions() {
    const secretKeyInstructions: JQuery<HTMLElement> = jQueryCourage('.secret-key-instructions');
    if (secretKeyInstructions.length > 0) {
      const instructionsNode: HTMLElement = secretKeyInstructions[0].childNodes[0] as HTMLElement;
      const instructionsTextNode: HTMLElement = instructionsNode.childNodes[0] as HTMLElement;
      if (instructionsTextNode) {
        instructionsTextNode.innerText = getLocalizedString('barcode.totp.manual.secret.key.instructions.text');
      }
    }
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    // Hide scan qr code button from footer as it gets forgified separately
    return (
      <ProxyFooter
        text={this.footerText}
        footerLinks={footerLink.not('[data-se="goto-link"]')}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
      />
    );
  }

  private moveScanQrCodeButton() {
    const footerLinks = jQueryCourage('div.auth-footer a[data-se="goto-link"]');
    if (footerLinks?.length > 0) {
      const scanQrCodeLink: HTMLElement = footerLinks[0];
      const oFormFieldsetContainer: JQuery<HTMLElement> = jQueryCourage('.o-form-fieldset-container');
      const scanQrCodeButtonContainer = createWrapper({ hidden: false });
      oFormFieldsetContainer.after(scanQrCodeButtonContainer);
      const component = (
        <div className='fe_u_text-align--center'>
          <Fragment key={'scan-qr-code'}>
            <ProxyButton
              textToOverride={getLocalizedString('mfa.athena.scanBarcode')}
              oktaButton={jQueryCourage(scanQrCodeLink)}
              variant='tertiary'
              size='small'
              fullWidth={false}
            />
          </Fragment>
        </div>
      );
      this.renderReactComponent({
        id: 'scan-qr-code-button',
        component,
        container: scanQrCodeButtonContainer,
      });
    }
  }


  private forgifySecretKeyInstructionsText() {
    const oktaSecretKeyInstructions: JQuery<HTMLElement> = jQueryCourage('.secret-key-instructions');
    if (oktaSecretKeyInstructions.length) {
      const forgeComponent = <SecretKeyInstructionsClassic container={oktaSecretKeyInstructions} />;
      this.renderForgeAndHideOktaComponent({
        id: oktaSecretKeyInstructions.attr('class')!,
        oktaComponent: oktaSecretKeyInstructions,
        forgeComponent: forgeComponent,
      });
    }
  }

}
